/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M11.37 17.363a.904.904 0 0 0-.065-1.274l-4.23-3.825a.4.4 0 0 1 .001-.594l4.18-3.754a.904.904 0 0 0 .07-1.275.898.898 0 0 0-1.27-.07L4.8 11.291a.904.904 0 0 0-.003 1.342L10.1 17.43a.898.898 0 0 0 1.271-.066ZM19.27 17.363a.904.904 0 0 0-.065-1.274l-4.23-3.825a.4.4 0 0 1 .001-.594l4.18-3.754a.904.904 0 0 0 .07-1.275.898.898 0 0 0-1.27-.07l-5.256 4.72a.904.904 0 0 0-.003 1.342L18 17.43a.898.898 0 0 0 1.271-.066Z"
})), "0 0 24 24", "ChevronDoubleBackward");